import { NotificationEventName } from './types';
import type { NotificationPayload } from '../../../types';

export type NotificationEventDetail = {
  notificationId: number;
  userNotificationId: number;
  type: string | null;
  payload: NotificationPayload | null;
};

export function dispatchNotificationEvent(
  eventName: NotificationEventName,
  detail: NotificationEventDetail,
) {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(eventName, { detail }));
}

export function subscribeNotificationEvent(
  eventName: NotificationEventName,
  listener: (event: CustomEvent<NotificationEventDetail>) => void,
) {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const nativeListener: EventListener = (event) => {
    listener(event as CustomEvent<NotificationEventDetail>);
  };

  window.addEventListener(eventName, nativeListener);
  return () => window.removeEventListener(eventName, nativeListener);
}
